import * as React from 'react'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { useTranslation } from 'react-i18next'

const DeleteYourContactDialogContent: React.FC = () => {
  const { t } = useTranslation()

  return (
    <>
      <DialogTitle id="delete-your-contact-title">{t('delete-your-contact-title')}</DialogTitle>
      <DialogContent>
        <DialogContentText id="delete-your-contact-description" paragraph>
          {t('delete-your-contact-text-1')}
        </DialogContentText>
        <DialogContentText id="delete-your-contact-description">{t('delete-your-contact-text-2')}</DialogContentText>{' '}
      </DialogContent>
    </>
  )
}

export default DeleteYourContactDialogContent
